import React, { useState, useEffect, useRef } from "react";
import InputTextElementElement from "../UiComponents/InputTextElement";
import ButtonElement from "../UiComponents/ButtonElement";
import { changePassword } from "../../Services/passwordService";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Message } from "primereact/message";
import Loader from "../UiComponents/Loader";
import useToggle from "../../Hooks/useToggle";
import ToastElement from "../UiComponents/ToastElement";

export const ResetPassword = () => {
  const { id } = useParams();
  const [data, setData] = useState({
    password_token: "",
    new_password: "",
    confirmPassword: "",
  });
  const [loader, setLoader] = useToggle();
  const navigate = useNavigate();
  const [message, setMessage] = useState("");
  const toastRef = useRef();

  const handleEvent = (e) => {
    setData((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async () => {
    setLoader();
    const res = await changePassword(id, data);
    if (res.data.message == 'Session Expired') {
      setMessage('Incorrect temporary password / Session Expired');
      setLoader();
      toastRef.current.showToast({
        type: 'error',
        message: 'Incorrect temporary password / Session Expired'
      });
    } else if (res.data.message == 'User Updated') {
      setMessage('Your password has been updated!');
      setLoader();
      toastRef.current.showToast({
        type: 'success',
        message: 'Your password has been updated!'
      });
      navigate("/login");
    }
  };

  return (
    <>
      <div className=''>
      <ToastElement ref={toastRef} />
        <div className='row mt-0'>
          <div className='col-lg-7 col-md-7 d-none d-md-block gradient-bg' >
            <div className="d-flex flex-column justify-content-center align-items-center h-100">
              <img src="/images/esg.svg" alt="testing error" className="mb-3 w-25" />
              <div className="d-flex flex-columnjustify-content-center align-items-center">
                <h3 className="text-left text-white">
                  ESG made Easy - to <br />operationalise ESG across your<br />Organisation
                </h3>
              </div>
            </div>
          </div>
          <div className='d-flex flex-column justify-content-center align-items-center col-lg-5 col-md-5 col-sm-12'>
            <div className='d-flex justify-content-center align-items-center w-75'>
              <img src="./images/myconsoleLogo.png" alt="" className="w-50 mt-5"/>
            </div>
            <div className='d-flex justify-content-center align-items-center mt-5 w-100'>
              <div className="px-3">
                <h3 className='welcome-heading mb-2'>Password Reset !!</h3>
                <p className="fs-8 m-0 mb-4">Enter details below to reset the password.</p>
                <div className='mt-4'>
                  <InputTextElementElement
                  className="mc-input w-100"
                  type="text"
                  placeholder="Enter Your Temporary Password"
                  name="password_token"
                  onChange={(e) => handleEvent(e)}
                  />
                </div>
                <div className='mt-4'>
                  <InputTextElementElement
                    className="mc-input w-100"
                    type="password"
                    placeholder="New Password"
                    name="new_password"
                    onChange={(e) => handleEvent(e)}
                  />
                </div>
                <div className='mt-4'>
                  <InputTextElementElement
                    className="mc-input w-100"
                    type="password"
                    placeholder="Confirm Password"
                    name="confirmPassword"
                    onChange={(e) => handleEvent(e)}
                  />
                </div>
                <div className='d-flex justify-content-end' >
                  <p className="password-text mt-20">
                    Password must be a minimum of 8 characters,including at least of
                    the following:upper & lower case letter,number and symbol
                  </p>
                </div>
                {message && message ? (
                    <Message severity="success" text={message} />
                  ) : null}
                <div className="d-flex mt-4 mb-5">
                  <ButtonElement
                    className="w-100 login-btn"
                    label="Change Password"
                    onClick={handleSubmit}
                  />
                </div>
                  {loader && loader ? <Loader loading={loader} /> : ""}
                </div>
              </div>
              <div className="footer">
                <div className="footer-content">
                  <p>© myConsole Ltd</p>
                  <p>
                    <Link to={"/securityPolicies"} className="ml-5">Privacy Policy</Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
    </>
  );
};
